module.exports = __webpack_public_path__ + "img/Instagram-black.be1a054c.svg";